import type { FC } from "react";

import { Skeleton } from "@/components/ui/skeleton";

/** Stands in while the drawer fetches the occupant it is about to edit — the
 * name row, then the two destination lists. */
const OccupantDrawerSkeleton: FC = () => (
  <div className="space-y-8 pb-4">
    <div className="grid gap-4 sm:grid-cols-2">
      <Skeleton className="h-16" />
      <Skeleton className="h-16" />
    </div>

    <div className="space-y-3">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-16" />
    </div>

    <div className="space-y-3">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-16" />
    </div>
  </div>
);

export default OccupantDrawerSkeleton;
